import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2MutationResult,
  IIndirectTaxFilingV2TriggerContributionSyncParams,
  IIndirectTaxFilingV2TriggerContributionSyncResponse,
} from './types';

/**
 * POST /api/v1/new-sales-tax/filings-v2/trigger-contribution-sync
 *
 * Admin-only re-run of the per-filing FILING_CONTRIBUTION SYNC pipeline.
 * Logical backend gates this by the agent-app role guard and forwards to
 * sales-tax-api-2's admin endpoint with the platform admin token. The
 * caller passes camelCase `filingIds`; logical backend translates to the
 * snake_case `filing_ids` body the Go handler expects.
 */
export async function triggerIndirectTaxFilingsV2ContributionSync({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2TriggerContributionSyncParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2TriggerContributionSyncResponse>
> {
  try {
    if (!params.filingIds || params.filingIds.length === 0) {
      return { success: false, error: 'filingIds must be a non-empty array' };
    }

    const response = await fetcher(
      'new-sales-tax/filings-v2/trigger-contribution-sync',
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to trigger contribution sync',
      };
    }
    return {
      success: true,
      data: json as IIndirectTaxFilingV2TriggerContributionSyncResponse,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to trigger contribution sync',
    };
  }
}
